export class OutputFiles {
    public static readonly CYCLE_SNAPSHOT_BASE = 'CycleParticipationData'
    public static readonly CYCLE_SNAPSHOT_UNATTESTED = '-preview';
    public static readonly CYCLE_SNAPSHOT_PIPE_DELIMITED = '.txt';
    public static readonly CYCLE_SNAPSHOT_CSV = '.csv';
    public static readonly ROSTER_IMPORT_SUMMARY = 'RosterImportSummaryData.csv';
}